export default ($http) => ({
  getResources () {
    return $http.get('resources')
  },
  getStandardOptionLinks(name) {
    return $http.get(`resources/links?sectionName=${name}`)
  }
})
